var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 52,
    viewBox: "0 0 70 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "timeFrame",
    transform: "translate(-1857 -1323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-timeframe-981072",
    transform: "translate(1787.005 1259.248)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11501",
    "data-name": "Path 11501",
    d: "M504.21,280.86h1.615v1.654H504.21Z",
    transform: "translate(-379.938 -191.056)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11502",
    "data-name": "Path 11502",
    d: "M439.142,306.23l-1.218-1.17,1.143-1.1,1.218,1.17Z",
    transform: "translate(-321.937 -211.387)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11503",
    "data-name": "Path 11503",
    d: "M413.75,370.46h1.723v1.551H413.75Z",
    transform: "translate(-300.785 -269.905)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11504",
    "data-name": "Path 11504",
    d: "M439.055,433.513l-1.142-1.1,1.218-1.169,1.142,1.1Z",
    transform: "translate(-321.928 -323.398)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11505",
    "data-name": "Path 11505",
    d: "M504.21,459.2h1.615v1.654H504.21Z",
    transform: "translate(-379.938 -347.996)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11506",
    "data-name": "Path 11506",
    d: "M565.829,432.87,564.61,431.7l1.142-1.1,1.219,1.169Z",
    transform: "translate(-432.788 -322.831)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11507",
    "data-name": "Path 11507",
    d: "M592.95,370.46h1.723v1.551H592.95Z",
    transform: "translate(-457.585 -269.905)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11508",
    "data-name": "Path 11508",
    d: "M565.765,306.853l-1.142-1.1,1.218-1.169,1.142,1.1Z",
    transform: "translate(-432.799 -211.936)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11509",
    "data-name": "Path 11509",
    d: "M494.194,315.192a2.688,2.688,0,0,0-1.938-2.481v-6h-1.615v6a2.631,2.631,0,0,0,.754,5.169,2.967,2.967,0,0,0,1.292-.31l3.231,3.1,1.185-1.137-3.231-3.1a2.663,2.663,0,0,0,.323-1.24Zm-3.877,0a1.186,1.186,0,0,1,2.369,0,.792.792,0,0,1-.323.724,1.24,1.24,0,0,1-2.046-.724Z",
    transform: "translate(-366.368 -213.809)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11510",
    "data-name": "Path 11510",
    d: "M131.811,88.563V66.854h-7v-3.1H123.2v3.2H115.55v-3.2h-1.615v3.2h-7.646v-3.2h-1.615v3.2H97.027v-3.2H95.411v3.2H87.765v-3.2H86.149v3.2H78.611v-3.2H77v3.2H70v42.386h42.646a15.136,15.136,0,0,0,12.385,6.409c8.185,0,14.969-6.409,14.969-14.369a14.362,14.362,0,0,0-8.185-12.819ZM77,68.4v1.551h1.615V68.4h7.646v1.551h1.615V68.4h7.646v1.551h1.615V68.4h7.646v1.551H106.4V68.4h7.646v1.551h1.615V68.4H123.3v1.551h1.615V68.4H130.3v4.652H71.611V68.4Zm-5.385,39.284V74.607H130.2V87.84a15.089,15.089,0,0,0-3.877-.827V78.225H111.027v12.2h4.2a14.145,14.145,0,0,0-5.169,10.855,13.214,13.214,0,0,0,1.615,6.409ZM117.6,88.976H112.75v-9.1h12.062v7.133a16.171,16.171,0,0,0-7.215,1.964Zm7.431,25.122c-7.323,0-13.354-5.789-13.354-12.819S117.7,88.46,125.027,88.46s13.354,5.789,13.354,12.819A13.092,13.092,0,0,1,125.027,114.1Z",
    transform: "translate(0 0)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11511",
    "data-name": "Path 11511",
    d: "M284.41,218.042l-1.185-1.654-1.293.827,2.046,2.895,6.677-4.342-.969-1.241Z",
    transform: "translate(-185.446 -132.682)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11512",
    "data-name": "Path 11512",
    d: "M141.505,330.9l-1.185-1.551-1.4.827,2.154,2.895,6.569-4.342-.861-1.344Z",
    transform: "translate(-60.309 -232)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11513",
    "data-name": "Path 11513",
    d: "M113.94,197.429h15.293v-12.2H113.94Zm1.616-10.648h12.062v9.1H115.556Z",
    transform: "translate(-38.452 -106.901)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11514",
    "data-name": "Path 11514",
    d: "M256.087,197.429h15.293v-12.2H256.086Zm1.615-10.648h12.062v9.1H257.7Z",
    transform: "translate(-162.829 -106.901)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11515",
    "data-name": "Path 11515",
    d: "M113.94,311.159h15.293v-12.2H113.94Zm1.616-10.649h12.062v9.1H115.556Z",
    transform: "translate(-38.452 -206.984)",
    fill: "#5da9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11516",
    "data-name": "Path 11516",
    d: "M256.087,311.159h15.293v-12.2H256.086ZM257.7,300.51h12.062v9.1H257.7Z",
    transform: "translate(-162.829 -206.984)",
    fill: "#5da9dd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeFrame);
export default __webpack_public_path__ + "static/media/timeFrame.1219d39bc980980e0e2d144746c3b1fb.svg";
export { ForwardRef as ReactComponent };